import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLoadContext } from "../../context/LoadContext";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default function Loader({ groups, iconSize }) {
  const loadContext = useLoadContext();
  return loadContext.isLoading(groups) ? (
    <FontAwesomeIcon icon={faSpinner} size={iconSize} spin />
  ) : (
    ""
  );
}
